// extracted by mini-css-extract-plugin
export default {"showMoreWrapper":"ButtonLoader_showMoreWrapper--wPQ","loaderWrap":"ButtonLoader_loaderWrap--GQU"};